module.exports = __webpack_public_path__ + "img/compare2.95b3e737.png";